<form [formGroup]="form" class="absence-request-form">
  <div class="detail-card-header p--16">
    <span class="w-h-header-span">
      <div class="single-header">
        {{ absenceUpdateRequest.title | translate }}
      </div>
    </span>
  </div>

  <mat-divider class="wh-dialog-divider"></mat-divider>
  <div class="p--16">
    <div class="flex--r-fs gap--16">
      <div class="flex-1">
        <div class="w-h-label">
          {{ absenceUpdateRequest.reasonText | translate }}
        </div>
        <mat-form-field style="width: 100%">
          <mat-label>{{
            "absencerequest.model.description" | translate
          }}</mat-label>
          <textarea rows="5" matInput formControlName="response"> </textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="dialog-action-wrapper" mat-dialog-actions>
      <w-h-button
        [text]="'app.cancel.label' | translate | uppercase"
        (clicked)="cancel()"
      />

      <w-h-button
        [text]="absenceUpdateRequest.buttonText | translate | uppercase"
        [color]="absenceUpdateRequest.isAccept ? 'accent' : 'warn'"
        [isLoading]="loading"
        [disabled]="form.invalid || loading"
        (clicked)="confirm()"
      />
    </div>
  </div>
</form>
